






































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import EventsBookingDetails from "../events/EventsBookingDetails.vue";

import SettingsJson from "../../shared/SettingsJson";
import ContactJson from "../../shared/ContactJson";
import EventJson from "../../shared/EventJson";
import EventBookingJson from "../../shared/EventBookingJson";
import { EventWithBookingsJson } from "../../shared/EventJson";
import { EventWithBookingJson } from "../../shared/EventJson";
import { EventBookingStatus, EventBookingStatusNames } from "../../shared/EventBookingStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "EventsIndividualBookings",
  components: {
    Loading,
    TableView,
    EventsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      EventBookingStatusNames: EventBookingStatusNames,
      bookedMailAddressesList: [] as string[],
      showDetails: false,
      detailsMode: "read",
      allEvents: null as EventJson[] | null,
      eventsMoreAvailable: null as boolean | null,
      selectedEventWithBookings: null as EventWithBookingsJson | null,
      selectedEventId: null as number | null,
      selectedEventBookingId: null as number | null,
      showOldEvents: false as boolean,
      loadingConfirmation: false as boolean,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: EventWithBookingJson | null, mode: string) {
      if (this.selectedEventId != null) {
        if (item != null) {
          this.selectedEventBookingId = item.ID;
        } else {
          this.selectedEventBookingId = null;
        }

        this.detailsMode = mode;
        this.toggleDetails();
      } else {
        alert("Es muss zuerst eine Veranstaltung ausgewählt werden.");
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllEvents();
    },

    async loadAllEvents(loadMore: null = null) {
      this.selectedEventId = null;
      this.selectedEventBookingId = null;
      this.selectedEventWithBookings = null;

      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.allEvents != null) {
        this.eventsMoreAvailable = null;
        skipAmount = this.allEvents.length;
      } else {
        this.allEvents = null;
      }

      if (this.restClient != null) {
        try {
          let events = await this.restClient.getEvents(
            null,
            false,
            false,
            false,
            null,
            null,
            null,
            null,
            true,
            skipAmount
          );

          if (loadMore && this.allEvents != null) {
            this.allEvents = this.allEvents.concat(events.events);
          } else {
            this.allEvents = events.events;
          }

          this.eventsMoreAvailable = events.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadSelectedEventWithBookings() {
      if (this.allEvents != null) {
        this.selectedEventWithBookings = null;

        if (this.restClient != null && this.selectedEventId != null) {
          try {
            this.selectedEventWithBookings = await this.restClient.getEventWithBookings(this.selectedEventId);
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    async sendBookingConfirmation(bookingId: number) {
      if (this.selectedEventId != null && bookingId != null && this.restClient != null) {
        this.loadingConfirmation = true;

        try {
          await this.restClient.confirmEventBooking(this.selectedEventId, bookingId);
          alert("Die Anfrage wurde gebucht und es wurde eine Bestätigung an den Kunden gesendet.");
          this.loadingConfirmation = false;
          this.loadSelectedEventWithBookings();
        } catch (e) {
          this.loadingConfirmation = false;
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadSelectedEventWithBookings();
    },

    getAllParticipantNames(participants: ContactJson[]) {
      var names = "";

      for (let i = 0; i < participants.length; i++) {
        if (i != 0) {
          names += ", ";
        }
        names += participants[i].firstName;
        names += " ";
        names += participants[i].lastName;
      }

      return names;
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }

      if (button == "sendBookingConfirmation") {
        this.sendBookingConfirmation(item.ID);
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.reloadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    filteredEvents(): EventJson[] | null {
      /* if (this.allEvents != null && !this.showOldEvents) {
        let today = new Date();
        let filtered = this.allEvents.filter((i: any) =>
          i.dates ? new Date(i.dates[i.dates.length - 1].endDateTime) > today : true
        );

        return filtered;
      } else {
        return this.allEvents;
      } */
      return this.allEvents;
    },

    eventColumns: function (): TableViewColumnDefinitions<EventBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Organisation",
          td: (i) => (i.contact && i.contact.organisation != "" ? i.contact.organisation : "--"),
        },
        {
          th: "Name (Kontaktperson)",
          td: (i) => (i.contact && i.contact.lastName != "" ? i.contact.lastName + ", " + i.contact.firstName : "--"),
        },
        {
          th: "Teilnehmende",
          td: (i) => {
            if (i.desiredDates) {
              return i.participantCount;
            } else {
              if (i.participants && i.participants.length > 0) {
                return vue.getAllParticipantNames(i.participants);
              } else {
                return "--";
              }
            }
          },
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.EventBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<EventBookingJson>[];
    },

    eventWaitinglistColumns: function (): TableViewColumnDefinitions<EventBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Organisation",
          td: (i) => (i.contact && i.contact.organisation != "" ? i.contact.organisation : "--"),
        },
        {
          th: "Name (Kontaktperson)",
          td: (i) => (i.contact && i.contact.lastName != "" ? i.contact.lastName + ", " + i.contact.firstName : "--"),
        },
        {
          th: "Teilnehmende",
          td: (i) => {
            if (i.desiredDates) {
              return i.participantCount;
            } else {
              if (i.participants && i.participants.length > 0) {
                return vue.getAllParticipantNames(i.participants);
              } else {
                return "--";
              }
            }
          },
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.EventBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Aufrücken und benachrichtigen",
          style: (i) => "text-align:right",
          button: "sendBookingConfirmation",
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<EventBookingJson>[];
    },

    requestedEventBookings(): EventBookingJson[] | null | undefined {
      if (this.selectedEventWithBookings != null) {
        var states = ["incomplete", "requested"];
        let requestedEventBookings = this.selectedEventWithBookings.bookings.filter((i) => states.includes(i.state));
        return requestedEventBookings;
      }
    },

    bookedEventBookings(): EventBookingJson[] | null | undefined {
      if (this.selectedEventWithBookings != null) {
        var states = [
          "bookedReadyForDepositPayment",
          "bookedDepositPaymentExported",
          "readyForPayment",
          "paymentExported",
        ];
        let requestedEventBookings = this.selectedEventWithBookings.bookings.filter((i) => states.includes(i.state));
        return requestedEventBookings;
      }
    },

    sortedBookedEventBookingsByParticipantLastName(): object[] | null | undefined {
      if (this.selectedEventWithBookings != null) {
        var states = ["booked", "readyForPayment", "paymentExported"];
        let bookedEventBookings = this.selectedEventWithBookings.bookings.filter((i: EventBookingJson) =>
          states.includes(i.state)
        );

        var participants = [];

        for (let i = 0; i < bookedEventBookings.length; i++) {
          if (bookedEventBookings[i].participants) {
            for (let j = 0; j < bookedEventBookings[i].participants!.length; j++) {
              var newObj: any = {};

              let k = bookedEventBookings[i].participants![j];
              let index: keyof typeof k;

              for (index in bookedEventBookings[i].participants![j]) {
                newObj[index] = bookedEventBookings[i].participants![j][index];
              }

              participants.push(newObj);
            }
          }
        }

        participants.sort(function (a, b) {
          let nameA = a.childLastName.toLowerCase();
          let nameB = b.childLastName.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        return participants;
      }
    },
  },
});
